(function(){"use strict";try{if(typeof document<"u"){var a=document.createElement("style");a.appendChild(document.createTextNode(".draggable--selected{background:var(--drag-drop-color)!important;opacity:.75!important}.draggable--hidden{background:var(--background-color)!important}.draggable--hidden>*{opacity:0!important}.drag-icon[data-v-da38ff47]{cursor:grab}div.v-snack:not(.v-snack--absolute){height:100%!important}[data-v-23223d98] .v-snackbar__wrapper{background-color:#333}.dialog-layout[data-v-24f056c1]{height:100%;background-color:var(--background-color)}.scrollbox[data-v-24f056c1]{max-height:734px;overflow:auto;scroll-behavior:smooth}.scrollbox--fullscreen[data-v-24f056c1]{max-height:100vh;overflow:auto;scroll-behavior:smooth}.scrollbox-ios-momentum[data-v-24f056c1]{overflow-y:scroll;-webkit-overflow-scrolling:touch}.scrollbox--hidden[data-v-24f056c1]{visibility:hidden}.scrollbox-content[data-v-24f056c1],.scrollbox[data-v-24f056c1]:hover,.scrollbox[data-v-24f056c1]:focus{visibility:visible}.v-toolbar-title[data-v-24f056c1]{min-width:calc(100% - 132px)}[data-v-24f056c1] .no-nav-icon .v-toolbar__title{padding-left:0!important}[data-v-24f056c1] .no-nav-icon .v-toolbar__content{padding-left:15px!important}.v-card[data-v-81090803]{background-color:inherit}.recaptcha-wrapper[data-v-81090803]{display:flex;justify-content:center;margin:16px 0}.dialog__card[data-v-44908dad]{width:100%;min-height:318px}.account-icon__icon-container[data-v-64ff61a0]{display:flex;align-items:center;justify-content:center;position:relative;width:28px;height:28px}.account-icon__icon[data-v-64ff61a0],.progress-circular__container[data-v-64ff61a0]{position:absolute}.v-menu__content[data-v-64ff61a0]{background-color:#fff}.account-icon__menu>.v-overlay__content{min-width:228px!important}.delete-account__card[data-v-0f682b8d]{border-color:red!important}.signing-in[data-v-0c0f5dcf]{min-height:100%;background-color:var(--background-color)}")),document.head.appendChild(a)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { VIcon as me, VSnackbar as Ze, VBtn as Q, VToolbar as et, VAppBarNavIcon as tt, VToolbarTitle as nt, VSpacer as Fe, VCard as pe, VTextField as ot, VDivider as Le, VRow as rt, VCol as it, VDialog as at, VMenu as st, VProgressCircular as we, VListSubheader as lt, VList as dt, VListItem as ct, VListItemTitle as ut, VCardTitle as ht, VCardSubtitle as ft, VCardActions as Be, VCardText as mt, VTable as pt, VRadioGroup as gt, VRadio as _t } from "vuetify/components";
import { resolveComponent as p, openBlock as g, createBlock as O, withCtx as c, createTextVNode as M, normalizeStyle as be, toDisplayString as F, createElementBlock as S, createCommentVNode as A, createElementVNode as C, renderSlot as K, createVNode as h, normalizeClass as de, resolveDynamicComponent as Ce, Fragment as le, pushScopeId as je, popScopeId as ze, resolveDirective as vt, renderList as qe, withDirectives as $e, vShow as Te, mergeProps as yt } from "vue";
import { ClickOutside as bt } from "vuetify/directives";
import { sendMail as Ct } from "vue-app-utils-web";
var oe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function It(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ie = { exports: {} };
/*! mobile-drag-drop 2.3.0-rc.1 | Copyright (c) 2019 Tim Ruffles | MIT License */
(function(e, t) {
  (function(n, a) {
    a(t);
  })(oe, function(n) {
    var a = "dnd-poly-", l = a + "snapback", r = "dnd-poly-", f = r + "dragstart-pending", x = r + "dragstart-cancel", w = ["none", "copy", "copyLink", "copyMove", "link", "linkMove", "move", "all"], d = ["none", "copy", "move", "link"], T = function() {
      var i = !1;
      try {
        var o = Object.defineProperty({}, "passive", { get: function() {
          i = !0;
        } });
        window.addEventListener("test", null, o);
      } catch {
      }
      return i;
    }();
    function P(i) {
      return i && i.tagName;
    }
    function E(i, o, s) {
      s === void 0 && (s = !0), document.addEventListener(i, o, !!T && { passive: s });
    }
    function k(i, o) {
      document.removeEventListener(i, o);
    }
    function L(i, o, s, v) {
      v === void 0 && (v = !1);
      var _ = T ? { passive: !0, capture: v } : v;
      return i.addEventListener(o, s, _), { off: function() {
        i.removeEventListener(o, s, _);
      } };
    }
    function B(i) {
      return i.length === 0 ? 0 : i.reduce(function(o, s) {
        return s + o;
      }, 0) / i.length;
    }
    function ee(i, o) {
      for (var s = 0; s < i.changedTouches.length; s++)
        if (i.changedTouches[s].identifier === o)
          return !0;
      return !1;
    }
    function X(i, o, s) {
      for (var v = [], _ = [], I = 0; I < o.touches.length; I++) {
        var D = o.touches[I];
        v.push(D[i + "X"]), _.push(D[i + "Y"]);
      }
      s.x = B(v), s.y = B(_);
    }
    var U = ["", "-webkit-"];
    function Y(i, o, s, v, _) {
      _ === void 0 && (_ = !0);
      var I = o.x, D = o.y;
      v && (I += v.x, D += v.y), _ && (I -= parseInt(i.offsetWidth, 10) / 2, D -= parseInt(i.offsetHeight, 10) / 2);
      for (var N = "translate3d(" + I + "px," + D + "px, 0)", $ = 0; $ < U.length; $++) {
        var G = U[$] + "transform";
        i.style[G] = N + " " + s[$];
      }
    }
    var ve = function() {
      function i(o, s) {
        this.t = o, this.i = s, this.s = d[0];
      }
      return Object.defineProperty(i.prototype, "dropEffect", { get: function() {
        return this.s;
      }, set: function(o) {
        this.t.mode !== 0 && w.indexOf(o) > -1 && (this.s = o);
      }, enumerable: !0, configurable: !0 }), Object.defineProperty(i.prototype, "types", { get: function() {
        if (this.t.mode !== 0)
          return Object.freeze(this.t.types);
      }, enumerable: !0, configurable: !0 }), Object.defineProperty(i.prototype, "effectAllowed", { get: function() {
        return this.t.effectAllowed;
      }, set: function(o) {
        this.t.mode === 2 && w.indexOf(o) > -1 && (this.t.effectAllowed = o);
      }, enumerable: !0, configurable: !0 }), i.prototype.setData = function(o, s) {
        if (this.t.mode === 2) {
          if (o.indexOf(" ") > -1)
            throw new Error("illegal arg: type contains space");
          this.t.data[o] = s, this.t.types.indexOf(o) === -1 && this.t.types.push(o);
        }
      }, i.prototype.getData = function(o) {
        if (this.t.mode === 1 || this.t.mode === 2)
          return this.t.data[o] || "";
      }, i.prototype.clearData = function(o) {
        if (this.t.mode === 2) {
          if (o && this.t.data[o]) {
            delete this.t.data[o];
            var s = this.t.types.indexOf(o);
            return void (s > -1 && this.t.types.splice(s, 1));
          }
          this.t.data = {}, this.t.types = [];
        }
      }, i.prototype.setDragImage = function(o, s, v) {
        this.t.mode === 2 && this.i(o, s, v);
      }, i;
    }();
    function ie(i, o) {
      return i ? i === w[0] ? d[0] : i.indexOf(w[1]) === 0 || i === w[7] ? d[1] : i.indexOf(w[4]) === 0 ? d[3] : i === w[6] ? d[2] : d[1] : o.nodeType === 3 && o.tagName === "A" ? d[3] : d[1];
    }
    function q(i, o, s, v, _, I, D) {
      I === void 0 && (I = !0), D === void 0 && (D = null);
      var N = function(G, W, te, ue, he, fe, R) {
        R === void 0 && (R = null);
        var H = W.changedTouches[0], V = new Event(te, { bubbles: !0, cancelable: ue });
        V.dataTransfer = fe, V.relatedTarget = R, V.screenX = H.screenX, V.screenY = H.screenY, V.clientX = H.clientX, V.clientY = H.clientY, V.pageX = H.pageX, V.pageY = H.pageY;
        var Ee = G.getBoundingClientRect();
        return V.offsetX = V.clientX - Ee.left, V.offsetY = V.clientY - Ee.top, V;
      }(o, s, i, I, document.defaultView, _, D), $ = !o.dispatchEvent(N);
      return v.mode = 0, $;
    }
    function ae(i, o) {
      if (!i || i === w[7])
        return o;
      if (o === d[1]) {
        if (i.indexOf(d[1]) === 0)
          return d[1];
      } else if (o === d[3]) {
        if (i.indexOf(d[3]) === 0 || i.indexOf("Link") > -1)
          return d[3];
      } else if (o === d[2] && (i.indexOf(d[2]) === 0 || i.indexOf("Move") > -1))
        return d[2];
      return d[0];
    }
    var se, u = function() {
      function i(o, s, v, _) {
        this.h = o, this.o = s, this.u = v, this.l = _, this.v = 0, this.p = null, this.g = null, this.m = o, this.I = o.changedTouches[0], this.j = this.C.bind(this), this.S = this.k.bind(this), E("touchmove", this.j, !1), E("touchend", this.S, !1), E("touchcancel", this.S, !1);
      }
      return i.prototype.A = function() {
        var o = this;
        this.v = 1, this.O = d[0], this.D = { data: {}, effectAllowed: void 0, mode: 3, types: [] }, this.M = { x: null, y: null }, this.F = { x: null, y: null };
        var s = this.u;
        if (this.N = new ve(this.D, function(N, $, G) {
          s = N, typeof $ != "number" && typeof G != "number" || (o.P = { x: $ || 0, y: G || 0 });
        }), this.D.mode = 2, this.N.dropEffect = d[0], q("dragstart", this.u, this.m, this.D, this.N))
          return this.v = 3, this.T(), !1;
        X("page", this.m, this.F);
        var v, _ = this.o.dragImageSetup(s);
        if (this.L = (v = _, U.map(function(N) {
          var $ = v.style[N + "transform"];
          return $ && $ !== "none" ? $.replace(/translate\(\D*\d+[^,]*,\D*\d+[^,]*\)\s*/g, "") : "";
        })), _.style.position = "absolute", _.style.left = "0px", _.style.top = "0px", _.style.zIndex = "999999", _.classList.add("dnd-poly-drag-image"), _.classList.add("dnd-poly-icon"), this._ = _, !this.P)
          if (this.o.dragImageOffset)
            this.P = { x: this.o.dragImageOffset.x, y: this.o.dragImageOffset.y };
          else if (this.o.dragImageCenterOnTouch) {
            var I = getComputedStyle(s);
            this.P = { x: 0 - parseInt(I.marginLeft, 10), y: 0 - parseInt(I.marginTop, 10) };
          } else {
            var D = s.getBoundingClientRect();
            I = getComputedStyle(s), this.P = { x: D.left - this.I.clientX - parseInt(I.marginLeft, 10) + D.width / 2, y: D.top - this.I.clientY - parseInt(I.marginTop, 10) + D.height / 2 };
          }
        return Y(this._, this.F, this.L, this.P, this.o.dragImageCenterOnTouch), document.body.appendChild(this._), this.V = window.setInterval(function() {
          o.X || (o.X = !0, o.Y(), o.X = !1);
        }, this.o.iterationInterval), !0;
      }, i.prototype.T = function() {
        this.V && (clearInterval(this.V), this.V = null), k("touchmove", this.j), k("touchend", this.S), k("touchcancel", this.S), this._ && (this._.parentNode.removeChild(this._), this._ = null), this.l(this.o, this.m, this.v);
      }, i.prototype.C = function(o) {
        var s = this;
        if (ee(o, this.I.identifier) !== !1) {
          if (this.m = o, this.v === 0) {
            var v = void 0;
            if (this.o.dragStartConditionOverride)
              try {
                v = this.o.dragStartConditionOverride(o);
              } catch {
                v = !1;
              }
            else
              v = o.touches.length === 1;
            return v ? void (this.A() === !0 && (this.h.preventDefault(), o.preventDefault())) : void this.T();
          }
          if (o.preventDefault(), X("client", o, this.M), X("page", o, this.F), this.o.dragImageTranslateOverride)
            try {
              var _ = !1;
              if (this.o.dragImageTranslateOverride(o, { x: this.M.x, y: this.M.y }, this.p, function(I, D) {
                s._ && (_ = !0, s.M.x += I, s.M.y += D, s.F.x += I, s.F.y += D, Y(s._, s.F, s.L, s.P, s.o.dragImageCenterOnTouch));
              }), _)
                return;
            } catch {
            }
          Y(this._, this.F, this.L, this.P, this.o.dragImageCenterOnTouch);
        }
      }, i.prototype.k = function(o) {
        if (ee(o, this.I.identifier) !== !1) {
          if (this.o.dragImageTranslateOverride)
            try {
              this.o.dragImageTranslateOverride(void 0, void 0, void 0, function() {
              });
            } catch {
            }
          this.v !== 0 ? (o.preventDefault(), this.v = o.type === "touchcancel" ? 3 : 2) : this.T();
        }
      }, i.prototype.Y = function() {
        var o = this, s = this.O;
        this.D.mode = 3, this.N.dropEffect = d[0];
        var v = q("drag", this.u, this.m, this.D, this.N);
        if (v && (this.O = d[0]), v || this.v === 2 || this.v === 3)
          return this.q(this.v) ? void function(N, $, G, W) {
            var te = getComputedStyle(N);
            if (te.visibility !== "hidden" && te.display !== "none") {
              $.classList.add(l);
              var ue = getComputedStyle($), he = parseFloat(ue.transitionDuration);
              if (isNaN(he) || he === 0)
                W();
              else {
                var fe = N.getBoundingClientRect(), R = { x: fe.left, y: fe.top };
                R.x += document.body.scrollLeft || document.documentElement.scrollLeft, R.y += document.body.scrollTop || document.documentElement.scrollTop, R.x -= parseInt(te.marginLeft, 10), R.y -= parseInt(te.marginTop, 10);
                var H = parseFloat(ue.transitionDelay), V = Math.round(1e3 * (he + H));
                Y($, R, G, void 0, !1), setTimeout(W, V);
              }
            } else
              W();
          }(this.u, this._, this.L, function() {
            o.B();
          }) : void this.B();
        var _ = this.o.elementFromPoint(this.M.x, this.M.y), I = this.g;
        _ !== this.p && _ !== this.g && (this.p = _, this.g !== null && (this.D.mode = 3, this.N.dropEffect = d[0], q("dragexit", this.g, this.m, this.D, this.N, !1)), this.p === null ? this.g = this.p : (this.D.mode = 3, this.N.dropEffect = ie(this.D.effectAllowed, this.u), q("dragenter", this.p, this.m, this.D, this.N) ? (this.g = this.p, this.O = ae(this.N.effectAllowed, this.N.dropEffect)) : this.p !== document.body && (this.g = document.body))), I !== this.g && P(I) && (this.D.mode = 3, this.N.dropEffect = d[0], q("dragleave", I, this.m, this.D, this.N, !1, this.g)), P(this.g) && (this.D.mode = 3, this.N.dropEffect = ie(this.D.effectAllowed, this.u), q("dragover", this.g, this.m, this.D, this.N) === !1 ? this.O = d[0] : this.O = ae(this.N.effectAllowed, this.N.dropEffect)), s !== this.O && this._.classList.remove(a + s);
        var D = a + this.O;
        this._.classList.add(D);
      }, i.prototype.q = function(o) {
        var s = this.O === d[0] || this.g === null || o === 3;
        return s ? P(this.g) && (this.D.mode = 3, this.N.dropEffect = d[0], q("dragleave", this.g, this.m, this.D, this.N, !1)) : P(this.g) && (this.D.mode = 1, this.N.dropEffect = this.O, q("drop", this.g, this.m, this.D, this.N) === !0 ? this.O = this.N.dropEffect : this.O = d[0]), s;
      }, i.prototype.B = function() {
        this.D.mode = 3, this.N.dropEffect = this.O, q("dragend", this.u, this.m, this.D, this.N, !1), this.v = 2, this.T();
      }, i;
    }(), m = { iterationInterval: 150, tryFindDraggableTarget: function(i) {
      var o = i.target;
      do
        if (o.draggable !== !1 && (o.draggable === !0 || o.getAttribute && o.getAttribute("draggable") === "true"))
          return o;
      while ((o = o.parentNode) && o !== document.body);
    }, dragImageSetup: function(i) {
      var o = i.cloneNode(!0);
      return function s(v, _) {
        if (v.nodeType === 1) {
          for (var I = getComputedStyle(v), D = 0; D < I.length; D++) {
            var N = I[D];
            _.style.setProperty(N, I.getPropertyValue(N), I.getPropertyPriority(N));
          }
          if (_.style.pointerEvents = "none", _.removeAttribute("id"), _.removeAttribute("class"), _.removeAttribute("draggable"), _.nodeName === "CANVAS") {
            var $ = v, G = _, W = $.getContext("2d").getImageData(0, 0, $.width, $.height);
            G.getContext("2d").putImageData(W, 0, 0);
          }
        }
        if (v.hasChildNodes())
          for (D = 0; D < v.childNodes.length; D++)
            s(v.childNodes[D], _.childNodes[D]);
      }(i, o), o;
    }, elementFromPoint: function(i, o) {
      return document.elementFromPoint(i, o);
    } };
    function y(i) {
      if (!se) {
        var o = m.tryFindDraggableTarget(i);
        if (o)
          try {
            se = new u(i, m, o, z);
          } catch (s) {
            throw z(m, i, 3), s;
          }
      }
    }
    function b(i) {
      var o = i.target, s = function($) {
        _.off(), I.off(), D.off(), N.off(), o && o.dispatchEvent(new CustomEvent(x, { bubbles: !0, cancelable: !0 })), clearTimeout(v);
      };
      o && o.dispatchEvent(new CustomEvent(f, { bubbles: !0, cancelable: !0 }));
      var v = window.setTimeout(function() {
        _.off(), I.off(), D.off(), N.off(), y(i);
      }, m.holdToDrag), _ = L(o, "touchend", s), I = L(o, "touchcancel", s), D = L(o, "touchmove", s), N = L(window, "scroll", s, !0);
    }
    function z(i, o, s) {
      if (s === 0 && i.defaultActionOverride)
        try {
          i.defaultActionOverride(o), o.defaultPrevented;
        } catch {
        }
      se = null;
    }
    n.polyfill = function(i) {
      if (i && Object.keys(i).forEach(function(_) {
        m[_] = i[_];
      }), !m.forceApply) {
        var o = (s = { dragEvents: "ondragstart" in document.documentElement, draggable: "draggable" in document.documentElement, userAgentSupportingNativeDnD: void 0 }, v = !!window.chrome || /chrome/i.test(navigator.userAgent), s.userAgentSupportingNativeDnD = !(/iPad|iPhone|iPod|Android/.test(navigator.userAgent) || v && "ontouchstart" in document.documentElement), s);
        if (o.userAgentSupportingNativeDnD && o.draggable && o.dragEvents)
          return !1;
      }
      var s, v;
      return m.holdToDrag ? E("touchstart", b, !1) : E("touchstart", y, !1), !0;
    }, Object.defineProperty(n, "__esModule", { value: !0 });
  });
})(Ie, Ie.exports);
var Dt = Ie.exports, De = { exports: {} };
(function(e, t) {
  (function(n, a) {
    a(t);
  })(oe, function(n) {
    function a(u) {
      return u === document.body || u === document.documentElement;
    }
    function l(u, m) {
      var y;
      if (a(u))
        y = m === 0 ? u.clientLeft : u.clientTop;
      else {
        var b = u.getBoundingClientRect();
        y = m === 0 ? b.left : b.top;
      }
      return y;
    }
    function r(u, m) {
      var y;
      return a(u) ? y = m === 0 ? window.innerWidth : window.innerHeight : y = m === 0 ? u.clientWidth : u.clientHeight, y;
    }
    function f(u, m, y) {
      var b = m === 0 ? "scrollLeft" : "scrollTop", z = a(u);
      if (arguments.length === 2)
        return z ? document.body[b] || document.documentElement[b] : u[b];
      z ? (document.documentElement[b] += y, document.body[b] += y) : u[b] += y;
    }
    function x(u) {
      var m = getComputedStyle(u);
      return u.scrollHeight > u.clientHeight && (m.overflowY === "scroll" || m.overflowY === "auto") || u.scrollWidth > u.clientWidth && (m.overflowX === "scroll" || m.overflowX === "auto");
    }
    function w(u) {
      do {
        if (!u)
          return;
        if (x(u))
          return u;
        if (u === document.documentElement)
          return null;
      } while (u = u.parentNode);
      return null;
    }
    function d(u, m, y) {
      return u < y ? -1 : m - u < y ? 1 : 0;
    }
    function T(u, m, y, b) {
      return u === -1 ? Math.abs(m - b) : u === 1 ? Math.abs(y - m - b) : 0;
    }
    function P(u, m, y) {
      var b = u === 0 ? y.scrollX : y.scrollY;
      if (m === 1) {
        var z = u === 0 ? y.scrollWidth - y.width : y.scrollHeight - y.height;
        return b >= z;
      } else if (m === -1)
        return b <= 0;
      return !0;
    }
    var E = {
      threshold: 75,
      velocityFn: function(u, m) {
        var y = u / m, b = y * y * y;
        return b * m;
      }
    }, k = {
      horizontal: 0,
      vertical: 0
    }, L = {
      x: 0,
      y: 0
    }, B, ee, X, U, Y;
    function ve(u, m, y, b) {
      ee = m, Y = b, X !== y && (X = y, U = w(X));
      var z = ae(ee, U, E.threshold, k, L);
      z ? ie() : B && (window.cancelAnimationFrame(B), B = null);
    }
    function ie() {
      B || (B = window.requestAnimationFrame(q));
    }
    function q() {
      var u = 0, m = 0, y = a(U);
      k.horizontal !== 0 && (u = Math.round(E.velocityFn(L.x, E.threshold) * k.horizontal), f(U, 0, u)), k.vertical !== 0 && (m = Math.round(E.velocityFn(L.y, E.threshold) * k.vertical), f(U, 1, m)), y ? Y(u, m) : Y(0, 0), B = null, ae(ee, U, E.threshold, k, L) && ie();
    }
    function ae(u, m, y, b, z) {
      if (!u || !m)
        return !1;
      var i = {
        x: l(m, 0),
        y: l(m, 1),
        width: r(m, 0),
        height: r(m, 1),
        scrollX: f(m, 0),
        scrollY: f(m, 1),
        scrollWidth: m.scrollWidth,
        scrollHeight: m.scrollHeight
      }, o = {
        x: u.x - i.x,
        y: u.y - i.y
      };
      return b.horizontal = d(o.x, i.width, y), b.vertical = d(o.y, i.height, y), b.horizontal && P(0, b.horizontal, i) ? b.horizontal = 0 : b.horizontal && (z.x = T(b.horizontal, o.x, i.width, y)), b.vertical && P(1, b.vertical, i) ? b.vertical = 0 : b.vertical && (z.y = T(b.vertical, o.y, i.height, y)), !!(b.horizontal || b.vertical);
    }
    var se = ve;
    n.scrollBehaviourDragImageTranslateOverride = se, Object.defineProperty(n, "__esModule", { value: !0 });
  });
})(De, De.exports);
var wt = De.exports;
const j = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, l] of t)
    n[a] = l;
  return n;
};
Dt.polyfill({
  dragImageTranslateOverride: wt.scrollBehaviourDragImageTranslateOverride
});
window.addEventListener("touchmove", function() {
}, {
  passive: !1
});
const kt = {
  name: "DragIcon",
  components: {
    VIcon: me
  },
  props: {
    itemId: {
      type: String,
      required: !0
    },
    orderedItemIds: {
      type: Array,
      required: !0
    },
    getDraggableElement: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.draggable.setAttribute("draggable", !0), this.draggable.addEventListener("dragstart", (e) => {
      this.dragstart(e);
    }), this.draggable.addEventListener("dragenter", (e) => {
      this.dragenter(e);
    }), this.draggable.addEventListener("dragover", (e) => {
      this.dragover(e);
    }), this.draggable.addEventListener("drop", (e) => {
      this.drop(e);
    }), this.draggable.addEventListener("dragend", (e) => {
      this.dragend(e);
    });
  },
  computed: {
    draggable() {
      return this.getDraggableElement(this.$el);
    }
  },
  methods: {
    setDragItem() {
      this.$store.setDragItemId(this.itemId), this.$store.setDragElement(this.draggable);
    },
    unsetDragItem() {
      this.$store.dragElement.classList.remove("draggable--hidden"), this.$store.dragElement.classList.remove("draggable--selected"), this.$store.setDragItemId(""), this.$store.setDragElement(null);
    },
    dragstart(e) {
      this.$store.dragItemId.length > 0 ? (e.dataTransfer.setData("text/plain", this.itemId), e.dataTransfer.effectAllowed = "move", this.draggable.classList.add("draggable--selected"), setTimeout(() => {
        this.draggable.classList.add("draggable--hidden");
      }, 100)) : e.preventDefault();
    },
    dragenter(e) {
      e.preventDefault(), e.dataTransfer.effectAllowed = "move";
    },
    dragover(e) {
      e.preventDefault(), e.dataTransfer.effectAllowed = "move", e.dataTransfer.dropEffect = "move";
      const t = this.$store.dragItemId, n = this.itemId;
      if (t !== n) {
        const a = [].concat(this.orderedItemIds), l = a.findIndex((f) => f === t), r = a.findIndex((f) => f === n);
        a.splice(l, 1), a.splice(r, 0, t), this.$emit("input", a);
      }
    },
    drop(e) {
      e.preventDefault();
    },
    dragend(e) {
      this.unsetDragItem();
    }
  }
};
function xt(e, t, n, a, l, r) {
  const f = p("v-icon");
  return g(), O(f, {
    class: "drag-icon",
    onMousedown: r.setDragItem,
    onTouchstart: r.setDragItem,
    onMouseup: r.unsetDragItem
  }, {
    default: c(() => [M(" mdi-drag-vertical ")]),
    _: 1
  }, 8, ["onMousedown", "onTouchstart", "onMouseup"]);
}
const Mt = /* @__PURE__ */ j(kt, [["render", xt], ["__scopeId", "data-v-da38ff47"]]);
var St = "Expected a function", Ue = "__lodash_hash_undefined__", Ge = 1 / 0, Pt = "[object Function]", Et = "[object GeneratorFunction]", $t = "[object Symbol]", Tt = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ot = /^\w*$/, At = /^\./, Nt = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Vt = /[\\^$.*+?()[\]{}|]/g, Ft = /\\(\\)?/g, Lt = /^\[object .+?Constructor\]$/, Bt = typeof oe == "object" && oe && oe.Object === Object && oe, jt = typeof self == "object" && self && self.Object === Object && self, ke = Bt || jt || Function("return this")();
function zt(e, t) {
  return e == null ? void 0 : e[t];
}
function qt(e) {
  var t = !1;
  if (e != null && typeof e.toString != "function")
    try {
      t = !!(e + "");
    } catch {
    }
  return t;
}
var Ut = Array.prototype, Gt = Function.prototype, Re = Object.prototype, ye = ke["__core-js_shared__"], Oe = function() {
  var e = /[^.]+$/.exec(ye && ye.keys && ye.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}(), Ye = Gt.toString, xe = Re.hasOwnProperty, He = Re.toString, Rt = RegExp(
  "^" + Ye.call(xe).replace(Vt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), Ae = ke.Symbol, Yt = Ut.splice, Ht = Xe(ke, "Map"), ce = Xe(Object, "create"), Ne = Ae ? Ae.prototype : void 0, Ve = Ne ? Ne.toString : void 0;
function J(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
function Xt() {
  this.__data__ = ce ? ce(null) : {};
}
function Wt(e) {
  return this.has(e) && delete this.__data__[e];
}
function Kt(e) {
  var t = this.__data__;
  if (ce) {
    var n = t[e];
    return n === Ue ? void 0 : n;
  }
  return xe.call(t, e) ? t[e] : void 0;
}
function Jt(e) {
  var t = this.__data__;
  return ce ? t[e] !== void 0 : xe.call(t, e);
}
function Qt(e, t) {
  var n = this.__data__;
  return n[e] = ce && t === void 0 ? Ue : t, this;
}
J.prototype.clear = Xt;
J.prototype.delete = Wt;
J.prototype.get = Kt;
J.prototype.has = Jt;
J.prototype.set = Qt;
function re(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
function Zt() {
  this.__data__ = [];
}
function en(e) {
  var t = this.__data__, n = ge(t, e);
  if (n < 0)
    return !1;
  var a = t.length - 1;
  return n == a ? t.pop() : Yt.call(t, n, 1), !0;
}
function tn(e) {
  var t = this.__data__, n = ge(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function nn(e) {
  return ge(this.__data__, e) > -1;
}
function on(e, t) {
  var n = this.__data__, a = ge(n, e);
  return a < 0 ? n.push([e, t]) : n[a][1] = t, this;
}
re.prototype.clear = Zt;
re.prototype.delete = en;
re.prototype.get = tn;
re.prototype.has = nn;
re.prototype.set = on;
function Z(e) {
  var t = -1, n = e ? e.length : 0;
  for (this.clear(); ++t < n; ) {
    var a = e[t];
    this.set(a[0], a[1]);
  }
}
function rn() {
  this.__data__ = {
    hash: new J(),
    map: new (Ht || re)(),
    string: new J()
  };
}
function an(e) {
  return _e(this, e).delete(e);
}
function sn(e) {
  return _e(this, e).get(e);
}
function ln(e) {
  return _e(this, e).has(e);
}
function dn(e, t) {
  return _e(this, e).set(e, t), this;
}
Z.prototype.clear = rn;
Z.prototype.delete = an;
Z.prototype.get = sn;
Z.prototype.has = ln;
Z.prototype.set = dn;
function ge(e, t) {
  for (var n = e.length; n--; )
    if (bn(e[n][0], t))
      return n;
  return -1;
}
function cn(e, t) {
  t = mn(t, e) ? [t] : fn(t);
  for (var n = 0, a = t.length; e != null && n < a; )
    e = e[vn(t[n++])];
  return n && n == a ? e : void 0;
}
function un(e) {
  if (!Ke(e) || gn(e))
    return !1;
  var t = Cn(e) || qt(e) ? Rt : Lt;
  return t.test(yn(e));
}
function hn(e) {
  if (typeof e == "string")
    return e;
  if (Se(e))
    return Ve ? Ve.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Ge ? "-0" : t;
}
function fn(e) {
  return We(e) ? e : _n(e);
}
function _e(e, t) {
  var n = e.__data__;
  return pn(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Xe(e, t) {
  var n = zt(e, t);
  return un(n) ? n : void 0;
}
function mn(e, t) {
  if (We(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Se(e) ? !0 : Ot.test(e) || !Tt.test(e) || t != null && e in Object(t);
}
function pn(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function gn(e) {
  return !!Oe && Oe in e;
}
var _n = Me(function(e) {
  e = Dn(e);
  var t = [];
  return At.test(e) && t.push(""), e.replace(Nt, function(n, a, l, r) {
    t.push(l ? r.replace(Ft, "$1") : a || n);
  }), t;
});
function vn(e) {
  if (typeof e == "string" || Se(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Ge ? "-0" : t;
}
function yn(e) {
  if (e != null) {
    try {
      return Ye.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
function Me(e, t) {
  if (typeof e != "function" || t && typeof t != "function")
    throw new TypeError(St);
  var n = function() {
    var a = arguments, l = t ? t.apply(this, a) : a[0], r = n.cache;
    if (r.has(l))
      return r.get(l);
    var f = e.apply(this, a);
    return n.cache = r.set(l, f), f;
  };
  return n.cache = new (Me.Cache || Z)(), n;
}
Me.Cache = Z;
function bn(e, t) {
  return e === t || e !== e && t !== t;
}
var We = Array.isArray;
function Cn(e) {
  var t = Ke(e) ? He.call(e) : "";
  return t == Pt || t == Et;
}
function Ke(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function In(e) {
  return !!e && typeof e == "object";
}
function Se(e) {
  return typeof e == "symbol" || In(e) && He.call(e) == $t;
}
function Dn(e) {
  return e == null ? "" : hn(e);
}
function wn(e, t, n) {
  var a = e == null ? void 0 : cn(e, t);
  return a === void 0 ? n : a;
}
var kn = wn;
const ne = /* @__PURE__ */ It(kn);
const xn = {
  name: "SnackbarMessages",
  props: {
    messageOnlyColor: {
      type: String,
      default: "var(--secondary-color)"
    }
  },
  components: {
    VSnackbar: Ze,
    VBtn: Q
  },
  // directives: {
  //   Ripple
  // },
  data() {
    return {
      forceHide: !1,
      showCountdown: !1,
      countdown: 0,
      actionPerformed: !1
    };
  },
  watch: {
    message: {
      handler: function() {
        this.message && !this.action && setTimeout(() => {
          this.close();
        }, this.autoCloseTimeout);
      },
      immediate: !0
    },
    action(e) {
      if (e && this.secondsBeforeActionIsForced > -1) {
        const t = (n) => {
          this.countdown = n, this.secondsOfCountdownToShow >= n && (this.showCountdown = !0), setTimeout(() => {
            this.actionPerformed || (n > 0 ? t(n - 1) : this.performAction());
          }, 1e3);
        };
        this.actionPerformed = !1, t(this.secondsBeforeActionIsForced);
      }
    }
  },
  computed: {
    showSnackbar() {
      return this.forceHide ? !1 : this.message && this.message.length > 0;
    },
    message() {
      return ne(this.$store.snackbarMessageProps, "[0].message");
    },
    messageStyles() {
      return this.action ? {} : {
        color: this.messageOnlyColor
      };
    },
    buttonStyles() {
      return {
        color: "primaryLight"
      };
    },
    autoCloseTimeout() {
      return ne(this.$store.snackbarMessageProps, "[0].autoCloseTimeout", 4e3);
    },
    action() {
      return ne(this.$store.snackbarMessageProps, "[0].action");
    },
    secondsBeforeActionIsForced() {
      return ne(this.$store.snackbarMessageProps, "[0].secondsBeforeActionIsForced", -1);
    },
    secondsOfCountdownToShow() {
      return ne(this.$store.snackbarMessageProps, "[0].secondsOfCountdownToShow", -1);
    },
    actionFn() {
      return ne(this.$store.snackbarMessageProps, "[0].actionFn", () => {
      });
    }
  },
  methods: {
    performAction() {
      this.actionFn(), this.actionPerformed = !0, this.showCountdown = !1, this.close();
    },
    close() {
      this.forceHide = !0, setTimeout(() => {
        this.$store.shiftSnackbarMessageProps(), this.forceHide = !1;
      }, 1e3);
    }
  }
}, Mn = {
  key: 0
};
function Sn(e, t, n, a, l, r) {
  const f = p("v-btn"), x = p("v-snackbar");
  return g(), O(x, {
    "model-value": r.showSnackbar,
    location: "bottom left",
    timeout: -1,
    vertical: !1
  }, {
    actions: c(() => [r.action ? (g(), O(f, {
      key: 0,
      class: "pr-3",
      style: be(r.buttonStyles),
      text: "",
      onClick: t[0] || (t[0] = (w) => r.performAction())
    }, {
      default: c(() => [M(F(r.action) + " ", 1), l.showCountdown ? (g(), S("span", Mn, "(" + F(l.countdown) + ")", 1)) : A("", !0)]),
      _: 1
    }, 8, ["style"])) : A("", !0)]),
    default: c(() => [C("div", {
      class: "message text-subtitle-1",
      style: be(r.messageStyles)
    }, F(r.message), 5)]),
    _: 1
  }, 8, ["model-value"]);
}
const Pn = /* @__PURE__ */ j(xn, [["render", Sn], ["__scopeId", "data-v-23223d98"]]), En = {
  name: "dialog-navigator",
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
function $n(e, t, n, a, l, r) {
  return g(), S("div", null, [K(e.$slots, "default")]);
}
const Tn = /* @__PURE__ */ j(En, [["render", $n]]);
const On = {
  name: "dialog-layout",
  components: {
    VToolbar: et,
    VAppBarNavIcon: tt,
    VIcon: me,
    VToolbarTitle: nt,
    VSpacer: Fe
  },
  props: {
    fullscreen: {
      type: Boolean,
      required: !0
    },
    navIcon: {
      type: String
    },
    title: {
      type: String,
      required: !0
    }
  },
  emits: ["pop-dialog"],
  data() {
    return {};
  }
}, An = {
  class: "dialog-layout"
}, Nn = {
  class: "dialog-content scrollbox-content"
};
function Vn(e, t, n, a, l, r) {
  const f = p("v-icon"), x = p("v-app-bar-nav-icon"), w = p("v-toolbar-title"), d = p("v-spacer"), T = p("v-toolbar");
  return g(), S("div", An, [h(T, {
    class: de({
      "no-nav-icon": !n.navIcon
    }),
    short: ""
  }, {
    default: c(() => [n.navIcon ? (g(), O(x, {
      key: 0,
      onClick: t[0] || (t[0] = (P) => e.$emit("pop-dialog"))
    }, {
      default: c(() => [h(f, null, {
        default: c(() => [M(F(n.navIcon), 1)]),
        _: 1
      })]),
      _: 1
    })) : A("", !0), h(w, null, {
      default: c(() => [M(F(n.title), 1)]),
      _: 1
    }), h(d), K(e.$slots, "toolbar-actions", {}, void 0, !0)]),
    _: 3
  }, 8, ["class"]), C("div", {
    class: de(["scrollbox", {
      "scrollbox--fullscreen": n.fullscreen
    }])
  }, [C("div", Nn, [K(e.$slots, "default", {}, void 0, !0)])], 2)]);
}
const Pe = /* @__PURE__ */ j(On, [["render", Vn], ["__scopeId", "data-v-24f056c1"]]);
const Fn = {
  name: "dialog-sign-in",
  components: {
    VBtn: Q,
    VCard: pe,
    VTextField: ot,
    VDivider: Le,
    VRow: rt,
    VCol: it,
    DialogLayout: Pe
  },
  inject: ["$auth", "$dialog"],
  props: {
    signInComponent: {
      type: String,
      required: !0
    },
    fullscreen: {
      type: Boolean,
      required: !0
    },
    navIcon: {
      type: String,
      required: !0
    },
    dark: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      countryCode: "1",
      phoneNumber: "",
      verificationCode: "",
      phoneError: "",
      codeError: "",
      showCodeForm: !1,
      sendingCode: !1,
      verifyingCode: !1,
      recaptchaConfigured: !1
    };
  },
  mounted() {
    this._setupRecaptcha();
  },
  methods: {
    signInWithGoogle() {
      this.$auth.signInWithGoogle();
    },
    signInAnonymously() {
      return this.$auth.signInAnonymously().then(() => {
        this.$dialog.pop();
      });
    },
    _setupRecaptcha() {
      this.$auth.configurePhoneAuth("recaptcha-container", "invisible"), this.recaptchaConfigured = !0;
    },
    async signInWithPhone() {
      this.phoneError = "";
      const e = this.countryCode.replace(/\D/g, ""), t = this.phoneNumber.replace(/\D/g, "");
      if (!e || !t) {
        this.phoneError = "Enter your country code and phone number.";
        return;
      }
      const n = `+${e}${t}`;
      this.sendingCode = !0;
      try {
        await this.$auth.sendPhoneVerificationCode(n), this.showCodeForm = !0;
      } catch (a) {
        this.phoneError = this._phoneErrorMessage(a);
      } finally {
        this.sendingCode = !1;
      }
    },
    async verifyPhoneCode() {
      if (this.codeError = "", !this.verificationCode) {
        this.codeError = "Enter the verification code.";
        return;
      }
      this.verifyingCode = !0;
      try {
        await this.$auth.verifyPhoneCode(this.verificationCode);
      } catch (e) {
        this.codeError = e.message || "Invalid code.";
      } finally {
        this.verifyingCode = !1;
      }
    },
    _phoneErrorMessage(e) {
      const t = e.code || "";
      return t.includes("invalid-phone-number") ? "Invalid phone number. Check your country code and number." : t.includes("too-many-requests") ? "Too many attempts. Please try again later." : t.includes("quota-exceeded") ? "SMS quota exceeded. Try again later." : e.message || "Failed to send code.";
    }
  }
}, Ln = (e) => (je("data-v-81090803"), e = e(), ze(), e), Bn = /* @__PURE__ */ Ln(() => /* @__PURE__ */ C("div", {
  id: "recaptcha-container",
  class: "recaptcha-wrapper"
}, null, -1));
function jn(e, t, n, a, l, r) {
  const f = p("v-btn"), x = p("v-divider"), w = p("v-text-field"), d = p("v-col"), T = p("v-row"), P = p("v-card"), E = p("dialog-layout");
  return g(), O(E, {
    title: "Sign in",
    fullscreen: n.fullscreen,
    navIcon: n.navIcon,
    dark: n.dark,
    onPopDialog: t[4] || (t[4] = (k) => e.$emit("pop-dialog")),
    onCloseDialog: t[5] || (t[5] = (k) => e.$emit("close-dialog"))
  }, {
    default: c(() => [h(P, {
      class: "pa-2 pt-3",
      flat: ""
    }, {
      default: c(() => [n.signInComponent.match(/^sign\-in/) ? (g(), O(Ce(n.signInComponent), {
        key: 0
      })) : A("", !0), r.$auth.hasGoogleProvider() ? (g(), S(le, {
        key: 1
      }, [h(f, {
        color: "primary",
        class: "mt-4",
        block: "",
        onClick: r.signInWithGoogle,
        "data-test": "google-sign-in-button"
      }, {
        default: c(() => [M(" Sign in with Google ")]),
        _: 1
      }, 8, ["onClick"]), h(x, {
        class: "my-4"
      })], 64)) : A("", !0), l.showCodeForm ? (g(), S(le, {
        key: 3
      }, [h(f, {
        variant: "text",
        size: "small",
        icon: "mdi-arrow-left",
        class: "mb-2",
        onClick: t[2] || (t[2] = (k) => l.showCodeForm = !1),
        "data-test": "back-to-phone-button"
      }), h(w, {
        modelValue: l.verificationCode,
        "onUpdate:modelValue": t[3] || (t[3] = (k) => l.verificationCode = k),
        label: "Verification code",
        type: "text",
        variant: "underlined",
        "error-messages": l.codeError,
        "data-test": "code-input"
      }, null, 8, ["modelValue", "error-messages"]), h(f, {
        color: "primary",
        block: "",
        loading: l.verifyingCode,
        onClick: r.verifyPhoneCode,
        "data-test": "verify-code-button"
      }, {
        default: c(() => [M(" Sign in ")]),
        _: 1
      }, 8, ["loading", "onClick"])], 64)) : (g(), S(le, {
        key: 2
      }, [h(T, {
        density: "comfortable"
      }, {
        default: c(() => [h(d, {
          cols: "3"
        }, {
          default: c(() => [h(w, {
            modelValue: l.countryCode,
            "onUpdate:modelValue": t[0] || (t[0] = (k) => l.countryCode = k),
            label: "Code",
            type: "tel",
            variant: "underlined",
            prefix: "+",
            "data-test": "country-code-input"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), h(d, {
          cols: "9"
        }, {
          default: c(() => [h(w, {
            modelValue: l.phoneNumber,
            "onUpdate:modelValue": t[1] || (t[1] = (k) => l.phoneNumber = k),
            label: "Phone number",
            type: "tel",
            variant: "underlined",
            "error-messages": l.phoneError,
            placeholder: "(555) 123-4567",
            "persistent-placeholder": "",
            "data-test": "phone-input"
          }, null, 8, ["modelValue", "error-messages"])]),
          _: 1
        })]),
        _: 1
      }), Bn, h(f, {
        color: "primary",
        variant: "outlined",
        block: "",
        loading: l.sendingCode,
        onClick: r.signInWithPhone,
        "data-test": "send-code-button"
      }, {
        default: c(() => [M(" Send code ")]),
        _: 1
      }, 8, ["loading", "onClick"])], 64)), r.$auth.hasAnonymousProvider() && (!r.$auth.isGuestSignInHidden() || r.$auth.store.guestSignInRevealed) ? (g(), O(f, {
        key: 4,
        color: "secondary",
        variant: "outlined",
        block: "",
        class: "mt-4",
        onClick: r.signInAnonymously,
        "data-test": "guest-sign-in-button"
      }, {
        default: c(() => [M(" Sign in as guest ")]),
        _: 1
      }, 8, ["onClick"])) : A("", !0)]),
      _: 1
    })]),
    _: 1
  }, 8, ["fullscreen", "navIcon", "dark"]);
}
const zn = /* @__PURE__ */ j(Fn, [["render", jn], ["__scopeId", "data-v-81090803"]]);
const qn = {
  name: "dialog-navigator",
  inject: ["$dialog"],
  components: {
    VDialog: at,
    VCard: pe,
    DialogContainer: Tn,
    DialogSignIn: zn
  },
  directives: {
    ClickOutside: bt
  },
  props: {
    isVDialog: {
      type: Boolean,
      default: !0
    },
    paramName: {
      type: String,
      default: "dialog"
    },
    dark: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {};
  },
  computed: {
    fullscreen() {
      return this.$vuetify.display.name === "xs";
    },
    navIcon() {
      return this.dialogNames.length > 1 ? "mdi-arrow-left" : "mdi-close";
    },
    // Can not use dialog.names because router.currentRoute is not reactive.
    dialogNames() {
      return this.$route.query[this.paramName] === void 0 ? [] : typeof this.$route.query[this.paramName] == "string" ? [this.$route.query[this.paramName]] : this.$route.query[this.paramName].slice();
    },
    nonSignInDialogNames() {
      return this.dialogNames.filter((e) => !e.match(/^sign-in/));
    },
    hasAnyDialogs() {
      return this.dialogNames.length > 0;
    },
    lastDialogName() {
      return this.dialogNames[this.dialogNames.length - 1] || "";
    }
  },
  methods: {
    pushDialog(e) {
      this.$dialog.push(e, void 0, this.paramName);
    },
    popDialog() {
      this.$dialog.pop(this.paramName);
    },
    overrideDialog(e) {
      this.$dialog.override(e, void 0, this.paramName);
    },
    closeDialog() {
      this.$dialog.close(this.paramName);
    },
    onClickOutside() {
      this.closeDialog();
    },
    shouldShowSignInDialog() {
      return !!this.lastDialogName.match(/^sign-in/);
    },
    otherElementsClickMustBeOutsideOf() {
      return [...document.querySelectorAll(".dialog__menu"), ...document.querySelectorAll(".dialog__card"), ...document.querySelectorAll(".v-select__content")];
    }
  }
};
function Un(e, t, n, a, l, r) {
  const f = p("v-card"), x = p("dialog-sign-in"), w = vt("click-outside");
  return g(), O(Ce(n.isVDialog ? "v-dialog" : "dialog-container"), {
    class: "dialog__container",
    eager: "",
    "model-value": r.hasAnyDialogs,
    "onUpdate:modelValue": r.closeDialog,
    fullscreen: r.fullscreen,
    width: r.fullscreen ? "100%" : "475px",
    scrollable: ""
  }, {
    default: c(() => [(g(!0), S(le, null, qe(r.nonSignInDialogNames, (d) => $e((g(), O(f, {
      class: de(["dialog__card elevation-20", {
        "dialog__card--not-full-screen": !r.fullscreen
      }]),
      key: d
    }, {
      default: c(() => [(g(), O(Ce("dialog-" + d.split("/")[0]), {
        fullscreen: r.fullscreen,
        navIcon: r.navIcon,
        dark: n.dark,
        onPopDialog: r.popDialog,
        onPushDialog: r.pushDialog,
        onCloseDialog: r.closeDialog
      }, null, 40, ["fullscreen", "navIcon", "dark", "onPopDialog", "onPushDialog", "onCloseDialog"]))]),
      _: 2
    }, 1032, ["class"])), [[Te, d === r.lastDialogName], [w, {
      handler: r.onClickOutside,
      include: r.otherElementsClickMustBeOutsideOf
    }]])), 128)), n.isVDialog ? $e((g(), O(f, {
      key: 0,
      class: de(["dialog__card elevation-20", {
        "dialog__card--not-full-screen": !r.fullscreen
      }])
    }, {
      default: c(() => [h(x, {
        signInComponent: r.lastDialogName,
        fullscreen: r.fullscreen,
        navIcon: r.navIcon,
        dark: n.dark,
        onPopDialog: r.popDialog,
        onPushDialog: r.pushDialog,
        onCloseDialog: r.closeDialog
      }, null, 8, ["signInComponent", "fullscreen", "navIcon", "dark", "onPopDialog", "onPushDialog", "onCloseDialog"])]),
      _: 1
    }, 8, ["class"])), [[Te, r.shouldShowSignInDialog()], [w, {
      handler: r.onClickOutside,
      closeConditional: r.shouldShowSignInDialog
    }]]) : A("", !0)]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue", "fullscreen", "width"]);
}
const Gn = /* @__PURE__ */ j(qn, [["render", Un], ["__scopeId", "data-v-44908dad"]]);
const Rn = {
  components: {
    VBtn: Q,
    VIcon: me,
    VMenu: st,
    VProgressCircular: we,
    VListSubheader: lt,
    VList: dt,
    VListItem: ct,
    VListItemTitle: ut,
    VDivider: Le
  },
  inject: ["$auth"],
  props: {
    paramName: {
      type: String,
      default: "dialog"
    },
    progressCircleColor: {
      type: String,
      required: !0
    }
  },
  data() {
    return {};
  },
  methods: {
    openSignInDialog() {
      const e = (({
        name: t,
        params: n,
        query: a
      }) => ({
        name: t,
        params: n,
        query: a
      }))(this.$route);
      this.$auth.openDialog(e, "sign-in-and-save-to-the-cloud", this.paramName);
    },
    navToAccount() {
      this.$router.push({
        name: "Account"
      }).catch((e) => {
        if (!e.message.match(/navigation guard/))
          throw e;
      });
    },
    navToAdmin() {
      this.$router.push({
        name: "Admin"
      }).catch((e) => {
        if (!e.message.match(/navigation guard/))
          throw e;
      });
    }
  }
}, Yn = {
  class: "account-icon"
}, Hn = {
  key: 1
}, Xn = {
  key: 0,
  class: "progress-circular__container"
}, Wn = {
  key: 1,
  "data-test": "nav-saved-indicator"
};
function Kn(e, t, n, a, l, r) {
  const f = p("v-icon"), x = p("v-btn"), w = p("v-progress-circular"), d = p("v-list-subheader"), T = p("v-divider"), P = p("v-list-item-title"), E = p("v-list-item"), k = p("v-list"), L = p("v-menu");
  return g(), S("div", Yn, [e.$store.isAuthenticated ? A("", !0) : (g(), O(x, {
    key: 0,
    onClick: t[0] || (t[0] = (B) => r.openSignInDialog()),
    icon: "",
    size: "medium",
    "data-test": "account-icon-unauthenticated"
  }, {
    default: c(() => [h(f, {
      class: de({
        "account-icon--authenticated": e.$store.isAuthenticated,
        "account-icon--unauthenticated": !e.$store.isAuthenticated
      })
    }, {
      default: c(() => [M(" mdi-account-circle-outline ")]),
      _: 1
    }, 8, ["class"])]),
    _: 1
  })), e.$store.isAuthenticated ? (g(), S("div", Hn, [h(L, {
    class: "account-icon__menu"
  }, {
    activator: c(({
      props: B
    }) => [C("div", yt({
      class: "account-icon__icon-container",
      "data-test": "account-icon"
    }, B), [e.$store.hasOpenTransactions ? (g(), S("div", Xn, [h(w, {
      indeterminate: "",
      color: n.progressCircleColor,
      size: 28
    }, null, 8, ["color"])])) : (g(), S("div", Wn)), h(x, {
      class: "account-icon__icon",
      icon: "",
      size: "medium"
    }, {
      default: c(() => [h(f, null, {
        default: c(() => [M(" mdi-account-circle ")]),
        _: 1
      })]),
      _: 1
    })], 16)]),
    default: c(() => [h(k, null, {
      default: c(() => [e.$store.user.signInMethod === "anonymous" ? (g(), O(d, {
        key: 0
      }, {
        default: c(() => [M("Signed in as Guest")]),
        _: 1
      })) : (g(), O(d, {
        key: 1
      }, {
        default: c(() => [M("Signed in with " + F(e.$store.user.signInMethod), 1)]),
        _: 1
      })), h(T), h(E, {
        title: "",
        onClick: r.navToAccount,
        "prepend-icon": "mdi-account-cog"
      }, {
        default: c(() => [h(P, null, {
          default: c(() => [M("Account")]),
          _: 1
        })]),
        _: 1
      }, 8, ["onClick"]), e.$store.user.role === "admin" ? (g(), O(E, {
        key: 2,
        title: "",
        onClick: r.navToAdmin,
        "prepend-icon": "mdi-account-key"
      }, {
        default: c(() => [h(P, null, {
          default: c(() => [M("Admin dashboard")]),
          _: 1
        })]),
        _: 1
      }, 8, ["onClick"])) : A("", !0), h(E, {
        "data-test": "account-icon__sign-out-menu-item",
        title: "",
        onClick: t[1] || (t[1] = (B) => r.$auth.signOut())
      }, {
        prepend: c(() => [h(f, null, {
          default: c(() => [M("mdi-logout")]),
          _: 1
        })]),
        default: c(() => [h(P, null, {
          default: c(() => [M("Sign out")]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })])) : A("", !0)]);
}
const Jn = /* @__PURE__ */ j(Rn, [["render", Kn], ["__scopeId", "data-v-64ff61a0"]]);
const Qn = {
  name: "AccountMaintenance",
  components: {
    VCard: pe,
    VCardTitle: ht,
    VCardSubtitle: ft,
    VCardActions: Be,
    VSpacer: Fe,
    VBtn: Q
  },
  inject: ["$auth"],
  data() {
    return {
      deleteAccountDisabled: !1
    };
  },
  methods: {
    deleteAccount() {
      this.deleteAccountDisabled = !0, this.$store.user.destroy().then(() => {
        this.$auth.signOut().then(() => {
          this.$store.pushSnackbarMessageProps({
            message: "Account deleted.",
            action: "OK"
          });
        });
      });
    }
  }
}, Je = (e) => (je("data-v-0f682b8d"), e = e(), ze(), e), Zn = /* @__PURE__ */ Je(() => /* @__PURE__ */ C("div", {
  class: "text-h5"
}, " Account maintenance ", -1)), eo = /* @__PURE__ */ Je(() => /* @__PURE__ */ C("div", {
  class: "delete-account__delete-btn"
}, " Delete my Account ", -1));
function to(e, t, n, a, l, r) {
  const f = p("v-card-title"), x = p("v-card-subtitle"), w = p("v-spacer"), d = p("v-btn"), T = p("v-card-actions"), P = p("v-card");
  return g(), S("div", null, [Zn, e.$store.user ? (g(), O(P, {
    key: 0,
    class: "delete-account__card mt-10",
    variant: "outlined"
  }, {
    default: c(() => [h(f, null, {
      default: c(() => [M("Delete account")]),
      _: 1
    }), h(x, null, {
      default: c(() => [M("Once you delete your account, there is no going back. All your content will be deleted too. Please be certain.")]),
      _: 1
    }), h(T, null, {
      default: c(() => [h(w), h(d, {
        class: "mr-2 mb-2",
        color: "warning",
        onClick: r.deleteAccount,
        disabled: l.deleteAccountDisabled
      }, {
        default: c(() => [eo]),
        _: 1
      }, 8, ["onClick", "disabled"])]),
      _: 1
    })]),
    _: 1
  })) : A("", !0)]);
}
const no = /* @__PURE__ */ j(Qn, [["render", to], ["__scopeId", "data-v-0f682b8d"]]);
const oo = {
  name: "SigningIn",
  components: {
    VProgressCircular: we
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.$router.replace({
        name: "Home"
      }).then(() => {
        this.$store.isAuthenticated || this.$store.pushSnackbarMessageProps({
          message: "Please sign-in again. There was a problem."
        });
      }).catch((e) => {
        if (!e.message.match(/navigation guard/))
          throw e;
      });
    }, 2e4);
  },
  unmounted() {
    clearTimeout(this.timeout);
  }
}, ro = {
  class: "signing-in d-flex justify-center align-center"
};
function io(e, t, n, a, l, r) {
  const f = p("v-progress-circular");
  return g(), S("div", ro, [h(f, {
    class: "mt-16",
    indeterminate: "",
    color: e.$vuetify.theme.current.colors.primary,
    size: 48
  }, null, 8, ["color"])]);
}
const ao = /* @__PURE__ */ j(oo, [["render", io], ["__scopeId", "data-v-0c0f5dcf"]]), so = {
  props: {
    fullName: {
      type: String,
      default: ""
    },
    addCardButtonDisabled: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    VCard: pe,
    VCardText: mt,
    VCardActions: Be,
    VBtn: Q
  },
  inject: ["$stripeManager"],
  data() {
    return {
      paymentTab: "CARD",
      addressElementsId: "",
      paymentElementsId: "",
      elements: null,
      addressElementsComplete: !1,
      paymentElementsComplete: !1
    };
  },
  created() {
    this.addressElementsId = "stripe-address-elements-" + this._uid, this.paymentElementsId = "stripe-payment-elements-" + this._uid;
  },
  watch: {
    "$stripeManager.latestSetupIntentClientSecret": {
      handler: function(e) {
        if (e) {
          this.elements = this.$stripeManager.stripe.elements({
            // API confirmed
            clientSecret: e,
            appearance: {
              variables: {
                fontFamily: ' "Roboto", sans-serif',
                borderRadius: "0",
                colorPrimaryText: "rgba(0, 0, 0, 0.87)"
              },
              rules: {
                ".Label": {
                  color: "rgba(0, 0, 0, 0.55)",
                  fontSize: "12px",
                  marginTop: "10px",
                  marginBottom: "0"
                },
                ".Label--invalid": {
                  color: "#ff5252"
                },
                ".Input": {
                  paddingTop: "5px",
                  paddingBottom: "5px",
                  paddingLeft: "0",
                  border: "0 0 2px 0",
                  borderBottomWidth: "1px",
                  borderBottomStyle: "solid",
                  borderBottomColor: "rgba(0, 0, 0, 0.42)",
                  outline: "none"
                },
                ".Input::placeholder": {
                  color: "rgba(0, 0, 0, 0.32)"
                },
                ".Input--invalid": {
                  color: "var(--colorPrimaryText)",
                  borderBottomColor: "#ff5252"
                },
                ".Input:focus": {
                  borderBottomWidth: "2px"
                },
                ".Error": {
                  color: "#ff5252",
                  fontSize: "12px"
                }
              }
            }
          });
          const t = this.elements.create("address", {
            mode: "billing",
            defaultValues: {
              name: this.fullName
            },
            fields: {
              phone: "always"
            },
            validation: {
              phone: {
                required: "always"
              }
            }
          }), n = this.elements.create("payment", {
            // API complete
            fields: {
              billingDetails: {
                name: "never",
                email: "never"
              }
            }
          }), a = () => {
            document.getElementById(this.addressElementsId) && document.getElementById(this.paymentElementsId) ? (t.mount("#" + this.addressElementsId), n.mount("#" + this.paymentElementsId), t.on("change", (l) => {
              this.addressElementsComplete = l.complete, this.$stripeManager.addPaymentErrorMessage = "";
            }), n.on("change", (l) => {
              this.paymentTab = l.value.type === "card" ? "CARD" : "ACCOUNT", this.paymentElementsComplete = l.complete, this.$stripeManager.addPaymentErrorMessage = "";
            })) : setTimeout(a, 100);
          };
          a();
        }
      },
      immediate: !0
    }
  },
  computed: {
    user() {
      return this.$store.user;
    }
  },
  methods: {
    onAddPaymentMethodClick() {
      this.user.privateProfile.microdepositType ? confirm("This will cancel your pending bank account setup. Is this ok?") && this.addPaymentMethod() : this.addPaymentMethod();
    },
    // [TODO] Not neccessary, but I would not mind extracting some of this code into $stripeManager
    addPaymentMethod() {
      this.$stripeManager.addPaymentErrorMessage = "", this.addressElementsComplete = !1, this.paymentElementsComplete = !1, this.$nextTick(async () => {
        const e = {
          email: this.user.privateProfile.paymentEmail || this.user.privateProfile.email
        }, {
          error: t,
          setupIntent: n
        } = await this.$stripeManager.stripe.confirmSetup({
          // API confirmed complete
          elements: this.elements,
          confirmParams: {
            return_url: this.$stripeManager.returnUrl(),
            payment_method_data: {
              billing_details: e
            }
          },
          redirect: "if_required"
        });
        t ? this.$stripeManager.addPaymentErrorMessage = this.$stripeManager.handleStripeIntentError(t, "setup") : (this.paymentTab === "CARD" && this.$stripeManager.waitForPaymentIntentUpdate(), this.$emit("close"), await this.$stripeManager.onSetupIntentConfirmed(n), this.paymentTab === "ACCOUNT" && this.sendEmail(e.email, n)), setTimeout(() => {
          this.addressElementsComplete = !0, this.paymentElementsComplete = !0;
        }, 500);
      });
    },
    pollForNewPaymentMethod(e, t) {
      const n = this.$stripeManager.loadedPaymentMethods.find((a) => a.stripePaymentMethodId === t);
      n ? e(n) : setTimeout(() => {
        this.pollForNewPaymentMethod(e, t);
      }, 250);
    },
    async sendEmail(e, t) {
      let n, a;
      const l = "Thank you for signing up for direct debits from UVMGen.", r = `You have authorized UVMGen to debit the bank account specified above for any amount owed for charges arising from your use of UVMGen’s services and/or purchase of products from UVMGen, pursuant to UVMGen’s website and terms, until this authorization is revoked. You may amend or cancel this authorization at any time on uvmgen.com.

Also, you have authorized UVMGen to debit your bank account periodically if and when you use UVMGen’s services or purchase more than one of UVMGen’s products periodically pursuant to UVMGen’s terms. Payments that fall outside of the regular debits authorized above will only be debited after your authorization is obtained.`, f = `If you have any questions, please reply to this email.

All the best,
The UVMGen team
feedback@uvmgen.com`;
      let x;
      if (t.status === "succeeded") {
        const d = await new Promise((P) => {
          this.pollForNewPaymentMethod(P, t.payment_method);
        }), T = `  Account Holder Name:    ${d.stripePaymentMethod.billing_details.name}
  Financial Institution:  ${d.stripePaymentMethod.us_bank_account.bank_name}
  Routing Number:         ${d.stripePaymentMethod.us_bank_account.routing_number}
  Account Number:         ****${d.last4}`;
        n = "UVMGen direct debits authorized", a = `${l}

${T}

${r}

${f}
`;
      } else if (t.status === "requires_action" && t.next_action && t.next_action.type === "verify_with_microdeposits") {
        n = "Next steps: Verify bank account on uvmgen.com";
        const d = t.next_action.verify_with_microdeposits.microdeposit_type === "descriptor_code", T = window.location.href + "&dialog=stripe-verify-microdeposits", P = "Once your account is verified, you may resume the purchase of your UVMGen on-premise license.", E = `To finish setting up your account you must enter a 6-digit code from your bank statement at ${T}. A $0.01 deposit will appear on your bank statement in 1 to 2 days. Please monitor your bank account for this transaction. ${P}`, k = `To finish setting up your account you must enter 2 transaction amounts from your bank statement at ${T}. These transactions will appear on your bank statement in 1 to 2 days. Please monitor your bank account for these transactions. ${P}`;
        a = `${l}

${d ? E : k}

${r}

${f}
`, x = "Check your inbox for further payment instructions.";
      }
      const w = "OK";
      Ct(e, "feedback@uvmgen.com", "UVMGen <feedback@uvmgen.com>", n, a, this.$store, x, w);
    }
  }
}, lo = {
  key: 0
}, co = ["id"], uo = ["id"], ho = {
  class: "mt-4 error--text"
};
function fo(e, t, n, a, l, r) {
  const f = p("v-card-text"), x = p("v-btn"), w = p("v-card-actions"), d = p("v-card");
  return g(), O(d, {
    style: {
      "max-width": "475px"
    },
    elevation: 0
  }, {
    default: c(() => [h(f, null, {
      default: c(() => [r.$stripeManager.stripe && r.$stripeManager.latestSetupIntentClientSecret ? (g(), S("div", lo, [K(e.$slots, "default"), l.addressElementsId ? (g(), S("div", {
        key: 0,
        class: "mt-5",
        id: l.addressElementsId
      }, null, 8, co)) : A("", !0), l.paymentElementsId ? (g(), S("div", {
        key: 1,
        class: "mt-10",
        id: l.paymentElementsId
      }, null, 8, uo)) : A("", !0), C("div", ho, F(r.$stripeManager.addPaymentErrorMessage), 1)])) : A("", !0)]),
      _: 3
    }), h(w, {
      class: "px-4"
    }, {
      default: c(() => [h(x, {
        class: "mt-2 mb-2 add-card-button",
        color: "primary",
        disabled: !l.elements || !l.paymentElementsComplete || !l.addressElementsComplete || n.addCardButtonDisabled,
        variant: "outlined",
        block: "",
        onClick: r.onAddPaymentMethodClick
      }, {
        default: c(() => [M(" ADD " + F(l.paymentTab), 1)]),
        _: 1
      }, 8, ["disabled", "onClick"])]),
      _: 1
    })]),
    _: 3
  });
}
const Qe = /* @__PURE__ */ j(so, [["render", fo]]), mo = {
  props: {
    fullName: {
      type: String,
      default: ""
    },
    addCardButtonDisabled: {
      type: Boolean,
      default: !1
    },
    showProgress: {
      type: Boolean,
      default: !0
    }
  },
  components: {
    StripeElements: Qe,
    VTable: pt,
    VProgressCircular: we,
    VBtn: Q,
    VRadioGroup: gt,
    VRadio: _t,
    VIcon: me
  },
  inject: ["$dialog", "$stripeManager"],
  computed: {
    user() {
      return this.$store.user;
    },
    loaded() {
      return this.user.paymentMethods.length === this.$stripeManager.loadedPaymentMethods.length;
    },
    openDialogDisabled() {
      return !this.loaded || !!([this.$router.currentRoute.value.query.dialog].flat() || []).find((e) => e === "stripe-elements");
    }
  },
  methods: {
    updateDefaultPaymentMethod(e) {
      e && this.$stripeManager.waitForPaymentIntentUpdate(), this.user.privateProfile.immediateUpdate({
        defaultPaymentMethodId: e,
        setupIntentErrorMessage: ""
      });
    },
    destroyPaymentMethod(e) {
      const t = e.id;
      e.destroy().then(() => {
        if (t === this.user.privateProfile.defaultPaymentMethodId) {
          const n = [...this.$stripeManager.loadedPaymentMethods].reverse().find((a) => a.id !== t);
          n ? this.updateDefaultPaymentMethod(n.id) : this.updateDefaultPaymentMethod("");
        }
      });
    },
    onVerify() {
      this.$dialog.push("stripe-verify-microdeposits");
    }
  }
}, po = {
  key: 0
}, go = {
  key: 0
}, _o = /* @__PURE__ */ C("thead", null, [/* @__PURE__ */ C("tr", null, [/* @__PURE__ */ C("th", {
  class: "text-left"
}, " Payment method "), /* @__PURE__ */ C("th", {
  class: "text-left"
}, " Expires "), /* @__PURE__ */ C("th", {
  class: "text-right"
})])], -1), vo = {
  class: "v-label theme--light"
}, yo = {
  style: {
    width: "70px"
  }
}, bo = {
  style: {
    display: "flex",
    "justify-content": "end"
  }
}, Co = {
  key: 0
}, Io = /* @__PURE__ */ C("td", null, [/* @__PURE__ */ C("span", {
  class: "v-label theme--light"
}, " n/a ")], -1), Do = {
  style: {
    height: "49px",
    width: "70px"
  }
}, wo = {
  style: {
    display: "flex",
    "justify-content": "end"
  }
}, ko = /* @__PURE__ */ C("tr", null, null, -1), xo = {
  class: "d-flex justify-start"
}, Mo = {
  key: 1,
  style: {
    width: "37px"
  }
}, So = {
  key: 1
}, Po = {
  class: "mt-4 text-body-1 error--text"
}, Eo = {
  key: 0
};
function $o(e, t, n, a, l, r) {
  const f = p("v-radio"), x = p("v-radio-group"), w = p("v-icon"), d = p("v-btn"), T = p("v-table"), P = p("v-progress-circular"), E = p("stripe-elements");
  return r.user.privateProfile && r.$stripeManager.paymentMethodsLoaded ? (g(), S("div", po, [r.user.paymentMethods.length > 0 || r.user.privateProfile.microdepositType ? (g(), S("div", go, [K(e.$slots, "list-title"), h(T, {
    class: "mt-6",
    density: "compact"
  }, {
    default: c(() => [_o, C("tbody", null, [(g(!0), S(le, null, qe(r.$stripeManager.loadedPaymentMethods, (k) => (g(), S("tr", {
      key: k.id
    }, [C("td", null, [h(x, {
      class: "mt-0",
      "hide-details": "",
      "model-value": r.user.privateProfile.defaultPaymentMethodId,
      "onUpdate:modelValue": r.updateDefaultPaymentMethod
    }, {
      default: c(() => [h(f, {
        label: k.description,
        value: k.id
      }, null, 8, ["label", "value"])]),
      _: 2
    }, 1032, ["model-value", "onUpdate:modelValue"])]), C("td", null, [C("span", vo, F(k.exp), 1)]), C("td", yo, [C("div", bo, [h(d, {
      style: be({
        "margin-right": r.user.privateProfile.microdepositType ? "20px" : "0"
      }),
      icon: "",
      variant: "flat",
      onClick: (L) => r.destroyPaymentMethod(k)
    }, {
      default: c(() => [h(w, {
        style: {
          color: "rgba(0, 0, 0, 0.35)"
        },
        size: "22"
      }, {
        default: c(() => [M(" mdi-delete ")]),
        _: 1
      })]),
      _: 2
    }, 1032, ["style", "onClick"])])])]))), 128)), r.user.privateProfile.microdepositType ? (g(), S("tr", Co, [C("td", null, [h(f, {
      label: "Pending bank account...",
      disabled: ""
    })]), Io, C("td", Do, [C("div", wo, [h(d, {
      color: "primary",
      variant: "text",
      onClick: r.onVerify
    }, {
      default: c(() => [M(" VERIFY ")]),
      _: 1
    }, 8, ["onClick"])])])])) : A("", !0), ko])]),
    _: 1
  }), C("div", xo, [!r.loaded && n.showProgress ? (g(), O(P, {
    key: 0,
    style: {
      "margin-top": "11px",
      "margin-left": "18px"
    },
    indeterminate: "",
    size: "19",
    color: "primary"
  })) : (g(), S("div", Mo)), h(d, {
    style: {
      "margin-top": "7px",
      "padding-left": "20px"
    },
    color: "primary",
    variant: "text",
    disabled: r.openDialogDisabled,
    onClick: t[0] || (t[0] = (k) => r.$dialog.push("stripe-elements"))
  }, {
    default: c(() => [M(" ADD ")]),
    _: 1
  }, 8, ["disabled"])])])) : (g(), S("div", So, [K(e.$slots, "add-card-title"), h(E, {
    class: "mt-6",
    "full-name": n.fullName,
    "add-card-button-disabled": n.addCardButtonDisabled
  }, {
    default: c(() => [K(e.$slots, "default")]),
    _: 3
  }, 8, ["full-name", "add-card-button-disabled"])])), C("div", Po, [C("div", null, F(r.user.privateProfile.setupIntentErrorMessage), 1), r.$stripeManager.defaultPaymentMethod && r.$stripeManager.defaultPaymentMethod.errorMessage ? (g(), S("div", Eo, F(r.$stripeManager.defaultPaymentMethod.errorMessage), 1)) : A("", !0)])])) : A("", !0);
}
const To = /* @__PURE__ */ j(mo, [["render", $o]]), Oo = {
  name: "dialog-stripe-elements",
  components: {
    DialogLayout: Pe
  },
  props: {
    fullscreen: {
      type: Boolean,
      required: !0
    },
    navIcon: {
      type: String,
      required: !0
    },
    dark: {
      type: Boolean,
      default: !1
    }
  }
};
function Ao(e, t, n, a, l, r) {
  const f = p("stripe-elements"), x = p("dialog-layout");
  return g(), O(x, {
    title: "Card information",
    fullscreen: n.fullscreen,
    navIcon: n.navIcon,
    dark: n.dark,
    onPopDialog: t[0] || (t[0] = (w) => e.$emit("pop-dialog"))
  }, {
    default: c(() => [h(f)]),
    _: 1
  }, 8, ["fullscreen", "navIcon", "dark"]);
}
const No = /* @__PURE__ */ j(Oo, [["render", Ao]]), Vo = {
  props: {
    cart: {
      type: Object,
      required: !0
    },
    companyName: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    VBtn: Q
  },
  inject: ["$dialog", "$stripeManager"],
  data() {
    return {};
  },
  computed: {
    buttonDisabled() {
      return this.$stripeManager.placeOrderButtonDisabled || !this.$stripeManager.defaultPaymentMethod.stripePaymentMethod.id || this.disabled;
    }
  }
}, Fo = {
  key: 0
}, Lo = {
  class: "ml-4 error--text"
}, Bo = {
  key: 0
}, jo = {
  class: "pa-4 d-flex flex-wrap flex-sm-nowrap justify-start",
  style: {
    border: "1px solid rgba(0, 0, 0, 0.15)",
    "border-radius": "5px"
  }
}, zo = {
  class: "ml-1"
}, qo = {
  class: "text-h6"
}, Uo = {
  class: "text-body-2"
}, Go = {
  style: {
    color: "rgba(0, 0, 0, 0.7)"
  }
};
function Ro(e, t, n, a, l, r) {
  const f = p("v-btn");
  return n.cart.result ? (g(), S("div", Fo, [C("div", Lo, [n.cart.result.paymentIntentErrorMessage ? (g(), S("div", Bo, F(n.cart.result.paymentIntentErrorMessage), 1)) : A("", !0), M("   ")]), C("div", jo, [h(f, {
    class: "ml-0 mr-6 mb-4 place-your-order-button",
    color: r.buttonDisabled ? "default" : "accent",
    loading: r.$stripeManager.placeOrderButtonDisabled || !r.$stripeManager.paymentIntentUpdated,
    disabled: r.buttonDisabled,
    elevation: "5",
    onClick: t[0] || (t[0] = (x) => r.$stripeManager.onPlaceYourOrder())
  }, {
    default: c(() => [M("PLACE YOUR ORDER")]),
    _: 1
  }, 8, ["color", "loading", "disabled"]), C("div", zo, [C("div", qo, " Order total: " + F(r.$stripeManager.formatPrice(n.cart.result.priceWithTax)), 1), C("div", Uo, [C("div", Go, [M(" By placing your order, you agree to " + F(n.companyName) + "'s ", 1), C("a", {
    onClick: t[1] || (t[1] = (x) => r.$dialog.override("privacy-policy"))
  }, "privacy notice"), M(" and "), C("a", {
    onClick: t[2] || (t[2] = (x) => r.$dialog.override("terms-of-service"))
  }, "conditions of use"), M(". ")])])])])])) : A("", !0);
}
const Yo = /* @__PURE__ */ j(Vo, [["render", Ro]]), Ho = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountIcon: Jn,
  AccountMaintenance: no,
  DialogLayout: Pe,
  DialogNavigator: Gn,
  DialogStripeElements: No,
  DragIcon: Mt,
  SigningIn: ao,
  SnackbarMessages: Pn,
  StripeCards: To,
  StripeElements: Qe,
  StripePayButton: Yo
}, Symbol.toStringTag, { value: "Module" })), Qo = function(t) {
  Object.entries(Ho).forEach(([n, a]) => {
    t.component(n, a);
  });
};
export {
  Jn as AccountIcon,
  no as AccountMaintenance,
  Pe as DialogLayout,
  Gn as DialogNavigator,
  No as DialogStripeElements,
  Mt as DragIcon,
  ao as SigningIn,
  Pn as SnackbarMessages,
  To as StripeCards,
  Qe as StripeElements,
  Yo as StripePayButton,
  Qo as default
};
//# sourceMappingURL=vue-app-components.esm.js.map
